import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-component',
  templateUrl: './error-component.component.html',
  styleUrls: ['./error-component.component.less']
})
export class ErrorComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
